module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prediction":"Stable rating outlook."},"ru":{"prediction":"Прогноз по&nbsp;рейтингу&nbsp;&mdash; стабильный."}}')
  delete Component.options._Ctor
}
